import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HierarchyViewEditComponent } from '../hierarchy-view-edit/hierarchy-view-edit.component';
import { Subscription } from 'rxjs';
import { HierarchyViewModel } from 'src/app/Modules/idms/models/hierarchy-view.model';
import { ViewDto } from '../../../models/instance/instance.model';

@Component({
    selector: 'app-hierarchy-idms-views',
    templateUrl: './hierarchy-idms-views.component.html',
    styleUrls: ['./hierarchy-idms-views.component.scss'],
})
export class HierarchyIdmsViewsComponent implements OnInit {
    @Input() idmsView: HierarchyViewModel[];
    @Input() instanceId: any;
    @Input() isCreate: boolean;
    @Input() idmstagItem: HierarchyViewModel[];
    @Output() updatePayload: EventEmitter<HierarchyViewModel> = new EventEmitter<HierarchyViewModel>();
    IsHierarchy: boolean = false;
    viewUpdateFrm: any;
    currentInstanceIdSubscription: Subscription;
    constructor(
        private modalService: NgbModal,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {}

    // * helper method to update views
    openHierarchyOptionEditModal(view: HierarchyViewModel) {
        const viewToBeUpdate: HierarchyViewModel = {
            ...view,
        };
        const dialogRef = this.modalService.open(HierarchyViewEditComponent, {
            size: 'md',
        });
        dialogRef.componentInstance.idmsView = this.isCreate ? this.idmsView : this.idmstagItem;
        dialogRef.componentInstance.View = view;
        dialogRef.componentInstance.instanceId = this.instanceId;
        dialogRef.componentInstance.IsHierarchy = view.name === 'Hierarchy';
        dialogRef.result
            .then((result: ViewDto) => {
                if (result) {
                    const targetArray = this.isCreate ? this.idmsView : this.idmstagItem;
                    const index = targetArray.findIndex((v) => v.name === viewToBeUpdate.name);
                    if (index !== -1) {
                        targetArray[index].name = result.Name;
                    }
                    if (!this.isCreate && index != -1) {
                        this.updatePayload.emit(targetArray[index]);
                    }
                    this.cd.detectChanges();
                }
            })
            .catch((error) => {
                console.warn(error);});
    }
}
